// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    secretId: z.string().min(1).max(21),
    connectorId: z.string().min(1).max(128),
    target: z.string().min(1).max(256),
    identityId: z.string().min(1).max(128),
});
const guard = z.object({
    tenantId: z.string().max(21),
    secretId: z.string().min(1).max(21),
    connectorId: z.string().min(1).max(128),
    target: z.string().min(1).max(256),
    identityId: z.string().min(1).max(128),
});
export const SecretSocialConnectorRelations = Object.freeze({
    table: 'secret_social_connector_relations',
    tableSingular: 'secret_social_connector_relation',
    fields: {
        tenantId: 'tenant_id',
        secretId: 'secret_id',
        connectorId: 'connector_id',
        target: 'target',
        identityId: 'identity_id',
    },
    fieldKeys: [
        'tenantId',
        'secretId',
        'connectorId',
        'target',
        'identityId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
